import React from 'react';

import { AssetsIcon } from '@atlaskit/logo';

import { Products } from '../../constants';
import type { FallbackUrl, GlobalShortcutConfiguration } from '../../types';
import { useAppGlobalShortcutLinkItem } from '../../utils/use-app-global-shortcut-link-item';

import { messages } from './messages';

const icon = <AssetsIcon size="xsmall" shouldUseNewLogoDesign label="" />;

export const useAssets = (fallbackUrl: FallbackUrl, options: GlobalShortcutConfiguration = {}) =>
	useAppGlobalShortcutLinkItem(icon, messages.label, fallbackUrl, {
		apsKey: Products.ASSETS,
		analyticsName: Products.ASSETS,
		...options,
	});
